import useBranch from "../atoms/useBranch";

const useBranchId = () => {
  const [branch] = useBranch();
  return branch?.id;
};

export default useBranchId;
